interface props {
  large?: boolean;
}
const SvgLikeContained: React.FC<props> = ({ large }) => {
  return (
    <svg
      style={large ? { transform: "scale(1.5)" } : {}}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.225 5.375C9 5.125 8.7 5 8.375 5H6.075C6.025 5 6 4.975 5.975 4.95C5.95 4.9 5.95 4.85 5.975 4.8C6.175 4.35 6.3 3.95 6.4 3.45C6.475 3.175 6.5 3 6.5 2.825C6.5 2.1 5.95 1.825 5.675 1.775C5.625 1.775 5.575 1.775 5.55 1.825C5.525 1.85 3.95 4.125 3.325 4.75C2.8 5.25 2.5 5.875 2.5 6.5V8.15C2.5 9.575 3.675 10.75 5.125 10.75H7.45C8.275 10.75 8.95 10.15 9.075 9.325L9.5 6.275C9.55 5.95 9.45 5.625 9.225 5.375Z"
        className="fill-current"
      />
    </svg>
  );
};

export default SvgLikeContained;
